import { combineReducers } from "redux";
import creditCard from "./creditCard";
import subscription from "./subscription";
import promo from "./promo";

export default combineReducers({
  creditCard,
  subscription,
  promo,
});
